import React from "react";
import useQRCode from "../hooks/useQRCode";

const QRPreview = ({ value, isValid }) => {
  const canvasRef = React.useRef(null);
  const { generateOnCanvas } = useQRCode();

  React.useEffect(() => {
    const render = async () => {
      const canvas = canvasRef.current;
      if (!canvas) return;

      // เคลียร์แคนวาสก่อนทุกครั้ง
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      if (!isValid) return;

      try {
        // รอ generate ให้เสร็จ (รวมรอโลโก้โหลดและวาดทับแล้ว)
        await generateOnCanvas(canvas, {
          text: (value.url || "").trim(),
          width: value.size,
          margin: value.margin,
          color: {
            dark: value.fgColor,
            light: value.bgColor,
          },
          errorCorrectionLevel: value.ecc,
          logoDataUrl: value.logoDataUrl || "",
        });
      } catch (e) {
        // เงียบไว้เพื่อไม่ให้เด้ง error UI
        // console.error(e);
      }
    };

    render();
    // ให้ re-render เมื่อค่าที่เกี่ยวข้องเปลี่ยน (โดยเฉพาะ logoDataUrl)
  }, [
    value.url,
    value.size,
    value.margin,
    value.fgColor,
    value.bgColor,
    value.ecc,
    value.logoDataUrl,
    isValid,
    generateOnCanvas,
  ]);

  return (
    <div className="qr-preview">
      {/* ใช้ key บน canvas เพื่อบังคับ remount เมื่อขนาดเปลี่ยน */}
      <canvas
        key={value.size}
        ref={canvasRef}
        width={value.size}
        height={value.size}
        style={{
          width: value.size,
          height: value.size,
          borderRadius: 12,
          boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
          background: value.bgColor,
        }}
      />
      {!isValid && (
        <div className="qr-preview-overlay">
          กรอก URL ให้ถูกต้องเพื่อแสดงพรีวิว
        </div>
      )}
    </div>
  );
};

export default QRPreview;
